export const GRID = "grid grid-cols-1 lg:grid-cols-2 my-44";

export const DETAIL_CONTAINER =
    "flex flex-col justify-start  lg:justify-center p-5 bg-[#FCF5F7] lg:p-12";

export const IMAGE_CONATINER = "w-full h-full order-1 lg:order-2 p-10 bg-[#FCF5F7]";

export const HEADING =
    "text-[24px] text-center lg:text-left lg:text-[36px] uppercase lg:text-[36px] font-semibold";

export const IMAGE_STYLES = "object-cover h-full w-full";

export const LIST = "flex items-center my-5";

export const LIST_ICON = "w-[12px] h-[12px]";

export const LIST_TEXT = "text-[16px] lg:text-[24px] font-[300] ml-2";

export const BTN = "ml-0 my-5";
